import { isEmptyOrWhitespace, styled } from "@shoothill/core";
import { useObserver } from "mobx-react-lite";
import React, { useState } from "react";
import { InductionAdminViewModel } from "../InductionAdminViewModel";
import MaterialTable from "material-table";
import { DarwinTablePageContent } from "Globals/Styles/AppStyling";
import { formatDate, formatTime } from "Utils/Format";
import { SHBox } from "Components/Box";
import { PatchedPagination } from "Components/Table/PatchedPagination";
import * as Defaults from "Globals/Defaults/TableOptions";
import { InductionAdminPermitListViewModel } from "./InductionAdminPermitListViewModel";
import { InductionAdminPermitListModel } from "./InductionAdminPermitListModel";

interface IProps {
    className?: string;
    viewModel: InductionAdminViewModel;
    inductionUserId: string;
}

const InductionAdminPermitViewBase: React.FC<IProps> = (props) => {
    const { viewModel, inductionUserId } = props;
    const [listViewModel] = useState(() => new InductionAdminPermitListViewModel(inductionUserId));
    // #region Code Behind

    const renderPage = () => {
        return (
            <DarwinTablePageContent>
                <MaterialTable
                    columns={[
                        { title: "Permit type", field: "permitTypeName" },
                        { title: "Permit no.", field: "permitNumber" },
                        {
                            title: "Issued by",
                            field: "issuedByDate",
                            render: (rowData: InductionAdminPermitListModel) => (
                                <SHBox>
                                    <SHBox>{rowData.issuedByDate ? `${formatDate(rowData.issuedByDate)} @ ${formatTime(rowData.issuedByDate.toString())} by ` : " "}</SHBox>
                                    <SHBox>{rowData.issuedByUserName ? `${rowData.issuedByUserName}` : " "}</SHBox>
                                </SHBox>
                            ),
                            defaultSort: "desc",
                        },
                        {
                            title: "Issued to",
                            field: "issuedToDate",
                            render: (rowData: InductionAdminPermitListModel) => (
                                <SHBox>
                                    <SHBox>{rowData.issuedToDate ? `${formatDate(rowData.issuedToDate)} @ ${formatTime(rowData.issuedToDate.toString())} to ` : " "}</SHBox>
                                    <SHBox>{rowData.issuedToUserName ? `${rowData.issuedToUserName}` : " "}</SHBox>
                                </SHBox>
                            ),
                        },
                        {
                            title: "Surrendered by",
                            field: "surrenderedDate",
                            render: (rowData: InductionAdminPermitListModel) => (
                                <SHBox>
                                    <SHBox>
                                        {!isEmptyOrWhitespace(rowData.surrenderedByDate)
                                            ? ` ${formatDate(rowData.surrenderedByDate!)} @ ${formatTime(rowData.surrenderedByDate!)} by `
                                            : " "}
                                    </SHBox>
                                    <SHBox>{!isEmptyOrWhitespace(rowData.surrenderedByUserName) ? rowData.surrenderedByUserName! : " "}</SHBox>
                                </SHBox>
                            ),
                        },
                        {
                            title: "Cancelled by",
                            field: "cancelledDate",
                            render: (rowData: InductionAdminPermitListModel) => (
                                <SHBox>
                                    <SHBox>
                                        {!isEmptyOrWhitespace(rowData.cancelledByDate)
                                            ? ` ${formatDate(rowData.cancelledByDate!)} @ ${formatTime(rowData.cancelledByDate!)} by `
                                            : " "}
                                    </SHBox>
                                    <SHBox>{!isEmptyOrWhitespace(rowData.cancelledByUserName) ? rowData.cancelledByUserName! : " "}</SHBox>
                                </SHBox>
                            ),
                        },
                    ]}
                    components={{
                        Pagination: PatchedPagination,
                    }}
                    options={Defaults.GetDarwinTableOptions()}
                    data={listViewModel.permitListModels}
                    onRowClick={(e, rowData) => {
                        listViewModel.handleRowClick(e, rowData!);
                    }}
                    title=""
                />
            </DarwinTablePageContent>
        );
    };

    return useObserver(() => renderPage());
};

export const InductionAdminPermitView = styled(InductionAdminPermitViewBase)``;
